import { render, staticRenderFns } from "./TemplateChangesTable.vue?vue&type=template&id=546bbbb6&"
import script from "./TemplateChangesTable.js?vue&type=script&lang=js&"
export * from "./TemplateChangesTable.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports